import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { KEYWORD_SERVICE_PAGES, keywordServiceHead } from "@/lib/keywordServicePages";

export const Route = createFileRoute("/best-seo-company-colorado")({
  head: () => keywordServiceHead(KEYWORD_SERVICE_PAGES.compareSeo),
  component: () => <KeywordServiceLanding page={KEYWORD_SERVICE_PAGES.compareSeo} />,
});